import { render, staticRenderFns } from "./Officers.vue?vue&type=template&id=a49f0306&scoped=true&"
import script from "./Officers.vue?vue&type=script&lang=ts&"
export * from "./Officers.vue?vue&type=script&lang=ts&"
import style0 from "./Officers.vue?vue&type=style&index=0&id=a49f0306&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49f0306",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBreadcrumbs,VCard,VDataTable})
